import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class ButcherSectionService {
    static getButcherSections(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`butcher-sections?filter=${qs}`, pageNumber));
    }
    static fetchButcherSection(oid) {
        return lastValueFrom(BaseService.get(`butcher-sections/${oid}`));
    }
    static saveButcherSection(dto) {
        return lastValueFrom(BaseService.save(`butcher-sections`, dto));
    }
    static deleteButcherSection(oid) {
        return lastValueFrom(BaseService.delete(`butcher-sections/${oid}`));
    }
    static searchButcherSectionCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`butcher-sections-search-dropdown/${selfId}?search=${qs}`));
    }
    // public static startButcherSectionWork(oid: number) {
    //   return lastValueFrom(BaseService.post<IEmptyDTO, IEmptyDTO>(`butcher-section-start-work/${oid}`, {}));
    // }
    // public static stopButcherSectionWork(oid: number) {
    //   return lastValueFrom(BaseService.post<IEmptyDTO, IEmptyDTO>(`butcher-section-stop-work/${oid}`, {}));
    // }
    static assignLotNumbers(filter) {
        return lastValueFrom(BaseService.post(`butcher-section-assign-lots`, filter));
    }
    static generateTransportDocuments(filter) {
        return lastValueFrom(BaseService.post(`butcher-section-generate-transport-documents`, filter));
    }
    static butcherSectionPrepare(filter) {
        return lastValueFrom(BaseService.post(`butcher-section-prepare`, filter));
    }
    static butcherTransformPrepare(filter) {
        return lastValueFrom(BaseService.post(`butcher-transform-prepare`, filter));
    }
    // ----------------------------------------------------------------------
    // ButcherSection Items
    // ----------------------------------------------------------------------
    static getButcherSectionItems(butcherSectionId) {
        //return lastValueFrom(BaseService.getPaginated<IButcherSectionItemDTO[]>(`butcher-section-items/${butcherSectionId}`, pageNumber));
        return lastValueFrom(BaseService.get(`butcher-section-items/${butcherSectionId}`));
    }
    static fetchButcherSectionItem(oid) {
        return lastValueFrom(BaseService.get(`butcher-section-item/${oid}`));
    }
    static saveButcherSectionItem(dto) {
        //return lastValueFrom(BaseService.save<IButcherSectionItem>(`butcher-section-items`, dto));
        return lastValueFrom(BaseService.post(`butcher-section-items`, dto));
    }
    static deleteButcherSectionItem(oid) {
        return lastValueFrom(BaseService.delete(`butcher-section-items/${oid}`));
    }
    static searchButcherSectionItemLotCombo(phaseCode, selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`butcher-section-items-lot-search-dropdown/${phaseCode}/${selfId}?search=${qs}`));
    }
}
